exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}.i8GjZVbGdHiwDniLDtbjKQ\\=\\={height:80px}html[dir] .i8GjZVbGdHiwDniLDtbjKQ\\=\\={background-color:#eaeaea}.TIwI\\+ZsfFOSFhfYpediJ9w\\=\\={height:80px}html[dir] .TIwI\\+ZsfFOSFhfYpediJ9w\\=\\={background-color:#eaeaea}.mWXImtXowNcyE6N-B3LBaA\\=\\={top:5px;position:relative}", ""]);
// Exports
exports.locals = {
	"nativeAdPreLoadStaticContainer": "i8GjZVbGdHiwDniLDtbjKQ==",
	"nativeAdPreLoadStaticContainerExp": "TIwI+ZsfFOSFhfYpediJ9w==",
	"nativeAdBoxContainerPosition": "mWXImtXowNcyE6N-B3LBaA=="
};